import Logo from '@/assets/logo.svg';
import { ROUTES } from '@/constants/routes';
import Link from 'next/link';

export const Footer = () => {
    const links = [
        { label: 'Platform Overview', path: ROUTES.Home },
        // { label: 'How It Works', path: ROUTES.HowItWorks },
        { label: 'Hyper Report', path: ROUTES.HyperReport },
        // TODO
        // { label: 'Blog', path: ROUTES.Home },
        // { label: 'FAQ', path: ROUTES.FAQ },
        // { label: 'Contact', path: ROUTES.ContactUs },
        // TODO
        { label: 'Terms', path: 'https://www.hyperfund.ai/terms.html' },
        // TODO
        { label: 'Privacy', path: 'https://www.hyperfund.ai/privacy.html' },
    ];

    return (
        <div className="p-8 md:p-12 lg:px-[220px] lg:py-[100px]">
            <div className="md:flex gap-[140px]">
                <div>
                    <div className="flex items-center gap-2">
                        <Logo height={28} width={32} viewBox="0 0 58 64" />
                        <h2 className="justify-start text-xl font-bold my-4">
                            Hyperfund AI
                        </h2>
                    </div>
                    <div className="max-lg:w-48 justify-start text-[10px]">
                        Make your raise inevitable with AI-powered investor
                        materials
                    </div>
                </div>
                <ul className="grid md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-x-[60px] lg:gap-y-8 lg:gap-x-[90px] mt-8">
                    {links.map(({ label, path }) => (
                        <li
                            key={label}
                            className="justify-start text-xs text-neutral-350"
                        >
                            <Link href={path}>{label}</Link>
                        </li>
                    ))}
                </ul>
            </div>
            <hr className="w-full my-8" />
            <div className="justify-start text-[10px] text-neutral-550">
                Copyright © 2025. HyperFund AI. All rights reserved.
            </div>
        </div>
    );
};
